import React from 'react';
import { RegisterInputContainer } from '../../../../../components/ui/InputSearch';
import { InputElement } from '../../../../../ui/Input/Input';
import { IRegisterForm } from '../../../../../interface/Auth/frontend';
import { useTranslation } from 'react-i18next';
import { useNameInput } from '../../../hooks/useNameInput';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
	isDisabled?: boolean;
}

export const RegFormName: React.FC<IProps> = ({ registerForm, setRegisterForm, isDisabled }) => {
	const { t } = useTranslation();

  const { handleChange, displayError } = useNameInput({
		citizenshipId: registerForm.citizenshipId,
		fieldName: 'name',
		currentValue: registerForm.name,
		onUpdate: (value) => setRegisterForm({ ...registerForm, name: value })
	});

	return (
		<RegisterInputContainer>
			<InputElement
				className={'registerNameInput'}
				placeholder={t('passport.registrationForm.nameForm.hint')}
				disabled={isDisabled}
				error={displayError}
				value={registerForm.name}
				onChange={handleChange}
			/>
		</RegisterInputContainer>
	);
};
